<template>
    <paper class="performanceDispatchOrder">
        <m-pane
            ref="tablePage"
            :virtual="true"
            :config="pageConfig"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :pickerConfig="timeRangeShortcuts"
            :searchTotalTitle="pageConfig.searchTotalTitle"
            :optionNum="optionNum"
            :loading="loading"
            searchId="dispatchOrderManagement"
            pageID="dispatchOrderTicket"
            :currentPage="page.pageNo"
            @sequence-btn="handleSequence"
            @viewLocationInformation-btn="viewLocationInformation"
            @arrivalRegistration-btn="arrivalRegistration"
            @cancelArrival-btn="cancelArrival"
            @detailedLoading-btn="detailedLoading"
            @transportProtocol-btn="transportProtocol"
            @trajectoryPlay-btn="trajectoryPlay"
            @wholeOrderLoading-btn="wholeOrderLoading"
            @dispatchDevice-btn="dispatchDevice"
            @taskDevice-btn="taskDevice"
            @parkAppoint-btn="parkAppoint"
            @print-btn="print"
            @printLog-btn="printLog"
            @onTheWay-btn="onTheWay"
            @arrivalConfirmation-btn="arrivalConfirmation"
            @cancelShipTo-btn="cancelShipTo"
            @costValidator-btn="costValidator"
            @costValidatorByCar-btn="costValidatorByCar"
            @costApprove-btn="costApprove"
            @grantingPrivileges-btn="grantingPrivileges"
            @costAnomaly-btn="costAnomaly"
            @dispatchEdit-btn="dispatchEdit"
            @billingTrial-btn="billingTrial"
            @issue-btn="issue"
            @cancelIssue-btn="cancelIssue"
            @contractLine-btn="contractLine"
            @depart-btn="depart"
            @editTransportationCost-btn="editTransportationCost"
            @row-db-click="rowDBclick"
            @viewTrack-btn="viewTrack"
            @abnormalReason-btn="abnormalReason"
            @photos-btn="photosBtn"
            @vehicleRecord-btn="vehicleRecord"
            @btnClick="btnClick"
            @cancelLoading-btn="cancelLoading"
            @inTransitEdit-btn="inTransitEdit"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        >
            <span slot="table-top">
                <el-radio-group v-model="isAll" @input="handleShowContent" style="margin-bottom: 8px;">
                    <el-radio-button :label="true">全部</el-radio-button>
                    <el-radio-button :label="false">排车下发直通宝异常</el-radio-button>
                </el-radio-group>
            </span>
            <span slot="search-list-advance-last">
                <el-dropdown style="margin-left: 8px">
                    <el-button type="primary">
                        标签<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="handleAddLabel">新建标签</el-dropdown-item>
                        <el-dropdown-item @click.native="handleLabelManage">标签管理</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </span>
            <div slot="table-module-btn">
                <!-- <el-tooltip effect='dark' content='发车单在途登记批量导入' placement='bottom'>
                        <el-button v-has="'/performance/dispatch-order/import'" icon='icon-daoru' size='mini' @click="showImport"></el-button>
                </el-tooltip> -->
                <reportExport
                    #default="{ submit }"
                    reportCode="TMS_DISPATCH_REPORT"
                >
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span v-has="'/performance/dispatch-order/export'" class="mgl-10 bigData-btn-export">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                :disabled="pageTotal === 0"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
                <reportExport
                    #default="{ submit }"
                    reportCode="TMS_DISPATCH_DETAIL_REPORT"
                >
                    <el-tooltip effect="dark" content="导出发车单商品明细" placement="bottom">
                        <span class="mgl-10" style="margin-left: 8px;">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                :disabled="pageTotal === 0"
                                @click="exportDetailFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <template v-slot:customTableCell="{ row, col }">
                <div class="table-list-encrypted-panel">
                    <span :style="cellStyle(row, col)">{{ row[col.prop] }}</span>
                </div>
            </template>
            <div slot="page-module-btn">
                <el-button
                    class="mgl-10 bigData-btn-batch-print"
                    type="primary"
                    @click="handleBatchPrint"
                    >批量打印</el-button
                >
                <!-- <el-button
                    type="primary"
                    :loading="btnLoading"
                    class="bigData-btn-batch-departure"
                    @click="handleBatchDepart(false)"
                    v-has="'150101036'"
                    >批量发车</el-button
                >
                <el-button
                    type="primary"
                    class="bigData-btn-departure-reason"
                    @click="handleRegistration"
                    v-has="'150101040'"
                    >整车异常发车原因</el-button
                >
                <el-button
                    type="primary"
                    class="bigData-btn-departure-rearrangement"
                    :loading="handleResetLoading"
                    @click="handleReset"
                    v-has="'150101049'"
                    >发车重排</el-button
                >
                <el-dropdown class="mgl-10">
                    <el-button type="primary">
                        计费重算<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                            class="bigData-btn-revenue-cost"
                            @click.native="handleIncomeCostRerun"
                            v-has="'150101044'"
                        >发车收入成本重算</el-dropdown-item>
                        <el-dropdown-item
                            class="bigData-btn-recalculation-revenue"
                            @click.native="handleIncomeRerun"
                            v-has="'150101045'"
                        >发车单收入重算</el-dropdown-item>
                        <el-dropdown-item
                            class="bigData-btn-recalculation-cost"
                            @click.native="handleCostRerun"
                            v-has="'150101046'"
                        >发车单成本重算</el-dropdown-item>
                        <el-dropdown-item
                            @click.native="handleRankRecalculate"
                            v-has="'150101053'"
                        >日趟数重算</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button
                    class="mgl-10"
                    type="primary"
                    @click="handleBillingTrial"
                    v-has="'150101051'"
                    >成本试算</el-button
                > -->
            </div>
        </m-pane>
        <!-- 新建标签弹窗 -->
        <add-label-dialog
            v-if="isShowAddLabel"
            ref="addLabel"
            :isShowAddLabel.sync="isShowAddLabel"
            :conditionList="conditionList"
            :columnList="columnList"
        ></add-label-dialog>
        <!-- 标签管理弹窗 -->
        <label-manage-dialog
            v-if="isShowLabelManage"
            ref="labelManage"
            :isShowLabelManage.sync="isShowLabelManage"
            @handleInitData="handleInitData"
        ></label-manage-dialog>

        <!-- 查看附件 -->
        <performance-preview-file
            ref="performancePreviewFile"
            :attachmentList="tableAttachmentList"
        ></performance-preview-file>

        <!-- 手工发车异常备注弹窗 -->
        <dispatch-abnormal-remark
            v-if="isShowRemarkDialog"
            ref="dispatchAbnormalRemark"
            :isShowRemarkDialog.sync="isShowRemarkDialog"
            :componentsData="componentsData"
            @depart="depart"
            @handleBatchDepart="handleBatchDepart"
            @closeRemarkDialog="closeRemarkDialog"
        ></dispatch-abnormal-remark>

        <!-- 电子围栏校验提示和备注 -->
            <dispatch-handle-reason
                v-if="isShowHandleReasonDialog"
                ref="dispatchHandleReason"
                :isShowHandleReasonDialog.sync="isShowHandleReasonDialog"
                :componentsData="componentsData"
                :handleType="handleType"
                @handleSuccess="depart"
                @closeFenceDialog="closeFenceDialog"
            ></dispatch-handle-reason>
        <!-- 电子围栏校验提示和备注 -->

        <!-- 新版打印窗口 -->
        <dispatch-new-print
            v-if="isShowNewPrintDialog"
            ref="dispatchNewPrint"
            :isShowNewPrintDialog.sync="isShowNewPrintDialog"
            :printConfig="printList"
            :dictData="dictData"
            :batchPrint="batchPrint"
            :componentsData="selected"
            :professionalCompanyConfig="professionalCompanyConfig"
            @openOldPrintDialog="openOldPrintDialog"
            ></dispatch-new-print>

        <dispatch-print-log
            v-if="isShowPrintLogDialog"
            ref="dispatchPrintLog"
            :isShowPrintLogDialog.sync="isShowPrintLogDialog"
            :componentsData="componentsData"
        ></dispatch-print-log>

        <operation-node-log
            ref="operationNodeLog"
            v-if="isShowOperationNodeLog"
            :isShowOperationNodeLog.sync="isShowOperationNodeLog"
            :dictData="dictData"
            :componentsData="componentsData"
        ></operation-node-log>

        <Import
            ref="Import"
            :ImportConfig="importConfig.ImportConfig"
            :ImportContent="importConfig.ImportContent"
            :verifyConfig="importConfig.verifyConfig"
            @reflashList="getList"
        ></Import>

        <!-- 弹窗组件集合 componentsName区分对应的组件 componentsData传给组件的数据-->
        <component
            :is="componentsName"
            @components-close="componentsClose"
            :componentsData="componentsData"
            :dictData="dictData"
            :professionalCompanyConfig="professionalCompanyConfig"
        ></component>

        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%"
            :before-close="handleCloseTip">
            <span>
                <i class="el-icon-warning-outline timeoutTip"></i>
                等待太久？您可以点击下方按钮，直接访问老版打印窗口。若继续等待，请不要退出界面，系统仍在匹配模板中，系统会根据匹配结果展示对应打印窗口。
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCloseTip">不打印了</el-button>
                <el-button type="primary" @click="handleOpenOldPrintf">跳转到老版打印界面</el-button>
            </span>
        </el-dialog>
    </paper>
</template>
<script>
import mPane from '@/components/lots/VirtualPanel/index.vue';
import { config, importConfig, operation, hideField } from './config.js';
import paper from '@/components/core/paper/Paper';
import reportExport from '@/components/lots/reportExportPlugin';
import { confirmBox } from '@/modules/transport/otp/views/distributeManage/dispatchMgmt/components/util/index';
// 位置信息查看
import DispatchPositionInfo from './components/dispatchPositionInfo/Index';
// 到车登记
import DispatchArrivalRegistration from './components/dispatchArrivalRegistration/Index';
// 取消到车
import DispatchCancelArrival from './components/dispatchCancelArrival/Index';
// 明细装车
import DispatchDetailedLoading from './components/dispatchDetailedLoading/Index';
// 打印
import DispatchPrint from './components/dispatchPrint/Index';
// 新打印弹窗
import DispatchNewPrint from './components/dispatchNewPrint/Index';
import DispatchPrintLog from './components/dispatchPrintLog/Index';
// 运输协议
import DispatchTransportProtocol from './components/dispatchTransportProtocol/Index';
// 轨迹回放
import DispatchTrajectoryPlay from './components/dispatchTrajectoryPlay/Index';
// 整单装车
import DispatchWholeOrderLoading from './components/dispatchWholeOrderLoading/Index';
// 发车单设备
import DispatchDevice from './components/dispatchDevice/Index';
// TK单设备
import TaskDevice from './components/taskDevice/Index';
// 园区预约
import DispatchParkAppoint from './components/dispatchParkAppoint/Index';
// 在途登记
import DispatchTransitRegistration from './components/dispatchTransitRegistration/Index';
// 运抵确认
import DispatchShipTo from './components/dispatchShipTo/Index';
// 取消零担下发
import DispatchCancelIssueModal from './components/dispatchCancelIssueModal/Index';
// 零担下发
import DispatchIssueModal from './components/dispatchIssueModal/Index';
// 合同外线路
import DispatchContractLine from './components/dispatchContractLine/Index';
// 在途编辑
import InTransitEdit from './components/dispatchInTransitEdit/Index';
// 操作日志
import operationNodeLog from './components/operationNodeLog/Index';
// 装车顺序
import DispatchSequence from './components/dispatchSequence/Index.vue';
import DispatchAbnormalReason from './components/dispatchAbnormalReason/Index';
// 新建标签
import AddLabelDialog from './labelManage/AddLabelDialog';
// 标签管理
import LabelManageDialog from './labelManage/labelManageDialog';
// 编辑运输成本
import DispatchTransportationCost from './components/dispatchTransportationCost/Index';
import TransportationCostLog from './components/transportationCostLog/Index';
// 查看附件
import PerformancePreviewFile from '@/modules/transport/otp/components/PerformancePreviewFile.vue';
// 手工发车异常备注
import DispatchAbnormalRemark from './components/dispatchAbnormalRemark/Index';
import Import from './components/Import/import.vue';
import { dictWithUrl } from '@/components/lots/api.js';
import { mapState, mapGetters } from 'vuex';
import {
    formatSearchData, validateSearchData, formatTotalDataList, isNoCarPlatformAndTianjinWangHuo, validateIsBatchDepart,
    formatSetSearchTime, isValidate, isEditTransport, isValidateReset, setAllPropertyValuesToNull
} from './util';
import { isValidateLoading, isValidateElectronic } from './components/dispatchDetailedLoading/util.js';
// 车辆改派记录
import DispatchVehicleRecord from './components/dispatchVehicleRecord/Index';
// 人工操作原因
import DispatchHandleReason from './components/dispatchHandleReason/Index';
import { judgeCost, startCostIflowApproval } from '@/modules/transport/otp/api/dispatchOrderNew.js';
import {
    cancleArrivalConfirm, queryByPage, queryCount, privilege, updatedepart, createZdc, lsrmCostVerification, costVerificationByCar,
    queryLtlPlatform, cpRecalculate, cancelLoadStatus, dispatchRearrange, isNeedExceptionRemarks,
    checkLclOperate, tryCalculation, rankRecalculate, queryTimeInterval
}
    from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
import { batchQueryTemplate, queryCompanyConfig } from '@/modules/transport/otp/api/performanceDispatchNewPrint.js';
import { seedIflowURLMap, currentEnv } from '@/modules/transport/otp/utils/iflowConf';
import bigDataLog from '@/utils/bigDataLog';
import getList from '@/components/awesome/page/mPanel3/api';

export default {
    name: 'performanceDispatchOrder',
    components: {
        mPane,
        paper,
        Import,
        reportExport,
        DispatchPositionInfo,
        DispatchArrivalRegistration,
        DispatchCancelArrival,
        DispatchDetailedLoading,
        DispatchPrint,
        DispatchNewPrint,
        DispatchPrintLog,
        DispatchTransportProtocol,
        DispatchTrajectoryPlay,
        DispatchWholeOrderLoading,
        DispatchDevice,
        TaskDevice,
        DispatchParkAppoint,
        DispatchTransitRegistration,
        DispatchShipTo,
        InTransitEdit,
        operationNodeLog,
        DispatchCancelIssueModal,
        DispatchContractLine,
        DispatchSequence,
        DispatchIssueModal,
        AddLabelDialog,
        LabelManageDialog,
        DispatchAbnormalReason,
        DispatchTransportationCost,
        TransportationCostLog,
        PerformancePreviewFile,
        DispatchVehicleRecord,
        DispatchAbnormalRemark,
        DispatchHandleReason
    },
    data () {
        return {
            pageConfig: JSON.parse(JSON.stringify(config)),
            timeRangeShortcuts: {
                shortcuts: [
                    { text: '今天', translate: '', today: true },
                    { type: 'd', num: 6, text: '最近一周', translate: '' },
                    { type: 'M', num: 1, text: '最近一个月', translate: '' },
                    { type: 'M', num: 2, text: '最近两个月', translate: '' }
                ]
            },
            importConfig: importConfig,
            isAll: true,
            loading: false,
            selected: [], // 选中数据
            totalData: [], // 列表数据
            printList: [],
            page: {
                pageSize: 100,
                pageNo: 1
            },
            dictData: {}, // 数据字典集合
            pageTotal: 0,
            currentPage: 1,
            searchParams: {},
            optionNum: '',
            resourceCode: '',
            dictContractLine: {}, // 合同外线路按钮权限控制 数据字典
            componentsName: '', // 组件名称
            componentsData: {}, // 行数据
            configurationUrl: config.configurationUrl ? config.configurationUrl : '/api-auth',
            isFirstSearch: true,
            dialogVisible: false,
            suspend: false,
            btnLoading: false, // 按钮加载动画
            isShowOperationNodeLog: false, // 操作日志弹窗显隐
            isShowAddLabel: false, // 是否显示新建标签弹窗
            isShowLabelManage: false, // 是否显示标签管理弹窗
            conditionList: '', // 当前查询条件
            columnList: '', // 当前列配置
            timeout: false,
            tableAttachmentList: [], // 列表附件查看列表
            handleResetLoading: false,
            isShowRemarkDialog: false, // 是否显示异常原因备注弹窗
            isShowHandleReasonDialog: false, // 是否显示围栏校验提示
            handleType: 'depart', // 操作类型：发车
            isShowNewPrintDialog: false,
            isShowPrintReasonDialog: false,
            repeatPrintReason: {},
            batchPrint: false, // 是否批量打印
            isShowPrintLogDialog: false,
            professionalCompanyConfig: {},
            maxSearchDay: 31 // 最大查询区间
        };
    },
    computed: {
        ...mapState({
            user: state => state.user,
            supplier: state => state.supplier,
            currentTenant: state => state.currentTenant
        }),
        ...mapGetters(['menus']),
        dataPowerFlag: function () {
            const flag = this.$_has('/performance/dispatch-order/label'); // /performance/dispatch-order/label 对应 数据权限 按钮权限的编码(运输收入，毛利率，毛利金额、目标价 三个字段的数据权限，由按钮权限控制)
            return flag;
        }
    },
    beforeRouteEnter (to, from, next) {
        const fromPath = ['/dispatch-Manage/dispatch-center-line', '/dispatch-Manage/base-platoon', '/dispatch-Manage/algorithm-dispatch', '/dispatch-Manage/new-dispatch-center'];
        if (fromPath.includes(from.path)) {
            next(vm => {
                vm.$nextTick(() => {
                    if (vm.$route.params && Object.keys(vm.$route.params).length) {
                        vm.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData.createTime = [vm.$route.params.createTimeStart, vm.$route.params.createTimeEnd];
                        vm.isAll = false;
                        vm.handleShowContent(false);
                        if (from.path === '/dispatch-Manage/base-platoon') {
                            vm.routeJumpSearch(true);
                        } else {
                            vm.routeJumpSearch(false);
                        }
                    }
                });
            });
        } else if (from.path.includes('/performance/waybill-detail')) {
            next(vm => {
                if (vm.$route.params.dispatchNo) {
                    vm.initialSearch();
                };
            });
        } else {
            next();
        }
    },
    methods: {
        handleShowContent(data) {
            this.loading = true;
            this.totalData = [];
            this.pageTotal = 0;
            if (data) {
                this.$nextTick(() => {
                    this.pageConfig = JSON.parse(JSON.stringify(config));
                    this.$refs.tablePage.$refs.table.maxOperationBtnNum = 3;
                    this.changeConfig();
                });
            } else {
                this.$nextTick(() => {
                    this.pageConfig.table.maxBtnNum = 2;
                    this.$refs.tablePage.$refs.table.maxOperationBtnNum = 2;
                    this.pageConfig.table.action = JSON.parse(JSON.stringify(operation));
                    this.changeConfig();
                });
            }
            setTimeout(() => {
                this.loading = false;
            }, 300);
        },
        async routeJumpSearch (truckFlag) {
            setAllPropertyValuesToNull(this.$refs.tablePage.$refs.searchList.searchData);
            this.loading = true;
            this.searchParams = {
                truckFlag,
                siteCode: this.$route.params.siteCodes,
                createTimeStart: this.$route.params.createTimeStart,
                createTimeEnd: this.$route.params.createTimeEnd,
                carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
            };
            await this.getDicData();
            await Promise.all([ this.getList(), this.getListPageCount() ])
                .catch(() => { })
                .finally(() => { this.loading = false; });
        },
        async initialSearch () {
            setAllPropertyValuesToNull(this.$refs.tablePage.$refs.searchList.searchData);
            this.loading = true;
            this.searchParams = {
                dispatchNoList: [this.$route.params.dispatchNo],
                carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
            };
            await this.getDicData();
            await Promise.all([ this.getList(), this.getListPageCount() ])
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                    this.isFirstSearch = false;
                });
        },
        /**
         * @description: 检查用户是否具有指定字段的数据权限，如果没有 则将配置文件中的对应的字段 过滤掉
         */
        changeConfig () {
            this.$nextTick(async () => {
                if (!this.dataPowerFlag) {
                    this.pageConfig.table.columns = this.pageConfig.table.columns.filter(item => !Object.keys(hideField).includes(item.prop));
                    const allColumnsProp = this.pageConfig.table.columns.map(v => v.prop).join(',');
                    const allColumns = this.pageConfig.table.columns.map(v => v.label).join(',');
                    const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
                    await this.deepMenu(menu);
                    // id属性为本地缓存使用，非接口属性
                    const params = {
                        'configName': allColumnsProp,
                        'configNameCn': allColumns,
                        'moduleCode': this.resourceCode,
                        'subjectType': 'columnsConfig',
                        'id': this.user.employeeId
                    };
                    return getList.get(this.configurationUrl, params).then(data => {
                        if (data.data && data.data.configNameCn) {
                            const tableList = data.data.configNameCn.split(',').filter(item => !Object.values(hideField).includes(item)).join(',');
                            this.handleInitData({ columnList: JSON.stringify(tableList) })
                        } else {
                            this.handleInitData({ columnList: JSON.stringify(allColumns) });
                        }
                    }).catch(() => {});
                }
            });
        },
        // 获取阿波罗配置的最大查询时间区间
        getMaxSearchLimit () {
            queryTimeInterval().then(res => {
                if (res && +res.code === 0) {
                    this.maxSearchDay = Number(res.data) || 31;
                }
            }).catch(() => { });
        },
        // 获取打印专司卡控配置
        queryCompanyConfig () {
            queryCompanyConfig().then(res => {
                if (res && +res.code === 0) {
                    this.professionalCompanyConfig = res.data || {};
                }
            }).catch(() => { });
        },
        // 双击列表
        rowDBclick (data) {
            this.$router.push({
                query: { dispatchNo: data.dispatchNo },
                path: `/performance/dispatch-order-detail`
            });
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.page.pageNo = 1;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        },
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData, this.maxSearchDay);
            // 执行操作
            if (!isQueryOk) return;
            this.searchParams = _searchData;
            this.page.pageNo = 1;
            this.getList();
            this.getListPageCount();
        },
        selectChange (data) {
            this.selected = data;
        },
        /**
         * @description 新建标签
         */
        handleAddLabel () {
            this.isShowAddLabel = true;
            // 获取当前查询条件和列配置
            const searchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet;
            const conditionList = {
                ...searchData[0].searchData,
                ...formatSetSearchTime(searchData[0].setSearchData)
            };
            this.conditionList = JSON.stringify(conditionList);
            this.columnList = JSON.stringify(this.$refs.tablePage.tableList);
        },
        /**
         * @description 标签管理
         */
        handleLabelManage () {
            this.isShowLabelManage = true;
        },
        /**
         * @description 标签管理-应用回调函数
         * @params {Object} data 应用行数据
         */
        async handleInitData (data) {
            if (data.columnList) {
                const columnList = this.dataPowerFlag
                    ? JSON.parse(data.columnList)
                    : JSON.parse(data.columnList).split(',').filter(v => !Object.values(hideField).includes(v)).join(','); // 无指定字段权限时，应用前先过滤
                // 表格应用
                this.$refs.tablePage.tableList = columnList;
                // 列配置应用
                const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
                await this.deepMenu(menu);
                const configProps = columnList.split(',').map(item => {
                    if (this.pageConfig.table.columns.find(column => column.label === item)) {
                        return this.pageConfig.table.columns.find(column => column.label === item).prop;
                    }
                }).join(',');
                const params = {
                    'configName': configProps,
                    'configNameCn': columnList,
                    'subjectType': 'columnsConfig',
                    'moduleCode': this.resourceCode,
                    'id': this.user.employeeId
                };
                const key = `${params.id}-${params.subjectType}-${params.moduleCode}`;
                localStorage.setItem(key, JSON.stringify(params.configNameCn));
                getList.post(this.configurationUrl, params).then(() => {});
            }
            if (data.conditionList) {
                const setSearchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData;
                const searchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].searchData || {};
                const searchList = JSON.parse(data.conditionList);
                // 赋值前清空所有查询条件
                Object.keys(searchData).forEach(item => {
                    searchData[item] = null;
                });
                // 查询条件赋值
                Object.keys(searchList).filter(v => setSearchData.hasOwnProperty(v)).forEach(item => {
                    setSearchData[item] = searchList[item];
                });
                // 高级查询赋值
                Object.keys(searchList).forEach(item => {
                    searchData[item] = searchList[item];
                });
            }
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const children = node.subResources;
                if (children) {
                    for (let i = 0; i < children.length; i++) {
                        if (children[i].frontUrl === this.$route.path) {
                            this.resourceCode = children[i].resourceCode;
                        } else {
                            this.deepMenu(children[i]);
                        }
                    }
                }
            }
        },

        /**
         * @description 获取列表分页数据
         */
        getListPageCount () {
            const params = this.getSearchData(this.searchParams);
            if (!this.isAll) params.param.ztbIssueStatus = 'N';
            queryCount(params.param).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },

        /**
         * @getList 获取列表接口
         * @param {Object} searchParams 查询条件
         */
        async getList () {
            this.loading = true;
            // 后端要求的格式
            if (this.searchParams.contractOutList) {
                this.searchParams.contractOutList = this.searchParams.contractOutList.map(item => Number(item));
            }
            if (this.searchParams.isIflow === '') {
                this.searchParams.isIflow = null;
            }
            if (this.searchParams.isIflow) {
                switch (this.searchParams.isIflow) {
                case 'false': this.searchParams.isIflow = false;
                    break;
                case 'true': this.searchParams.isIflow = true;
                    break;
                default: this.searchParams.isIflow = null;
                }
            }
            const params = this.getSearchData(this.searchParams);
            if (!this.isAll) params.param.ztbIssueStatus = 'N';
            queryByPage(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.totalData = formatTotalDataList(res.data.list || [], this.dictData, this.dictContractLine);
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.isFirstSearch = false;
                });
        },
        showImport() {
            this.$nextTick(() => {
                this.$refs.Import.orderImportC();
            });
        },
        /**
         * @description 导出
        */
        async exportFile (submit) {
            const doSubmit = () => {
                const exportParam = {
                    ...this.searchParams,
                    startCreateTime: this.searchParams.createTimeStart,
                    endCreateTime: this.searchParams.createTimeEnd,
                    tenantCode: this.currentTenant.tenantCode,
                    requestResults: this.$refs.tablePage.tableList,
                    beginDate2: '2020-11-11 00:00:00', // 后端固定要传参数
                    endDate2: '2020-11-11 00:00:00',
                    carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
                };
                if (!this.isAll) exportParam.ztbIssueStatus = 'N';
                submit(exportParam);
            };
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            doSubmit();
        },
        /**
         * @description 导出
        */
        async exportDetailFile (submit) {
            const dispatchGoodsReportNum = this.dictData['DISPATCH_GOODS_REPORT_NUM'].data;
            if (this.pageTotal > dispatchGoodsReportNum) {
                this.$message.warning(`一次最多查询${dispatchGoodsReportNum}个发车单进行商品明细导出，请缩减数量后再试`);
                return false;
            }
            const doSubmit = () => {
                const exportParam = {
                    ...this.searchParams,
                    startCreateTime: this.searchParams.createTimeStart,
                    endCreateTime: this.searchParams.createTimeEnd,
                    tenantCode: this.currentTenant.tenantCode,
                    beginDate2: '2020-11-11 00:00:00', // 后端固定要传参数
                    endDate2: '2020-11-11 00:00:00',
                    carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
                };
                if (!this.isAll) exportParam.ztbIssueStatus = 'N';
                submit(exportParam);
            };
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            doSubmit();
        },
        // 参数为空处理
        getSearchData (data) {
            const _searchData = {
                ...this.page,
                param: {
                    ...data,
                    carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
                }
            };
            for (const key in _searchData) {
                if (_searchData[key] === '') delete _searchData[key];
            }
            return _searchData;
        },
        // 发车收入成本重算
        handleIncomeCostRerun () {
            this.callApi('RP', '发车收入成本重算成功！');
        },
        // 发车单收入重算
        handleIncomeRerun () {
            this.callApi('R', '发车单收入重算成功！');
        },
        // 发车单成本重算
        handleCostRerun () {
            this.callApi('P', '发车单成本重算成功！');
        },
        /**
         * @description 可复用的api调用，动态参数及提示信息
         * @param {verificationFlag} 是否检验 分拨收入
         * @param {param} 参数中的 rpFlag字段 （ R收入，P成本，RP收入成本 ）
         * @param {tip} 提示信息
         */
        callApi(param, tip) {
            const data = this.verificationData();
            if (data && data.length) {
                const params = {
                    dispatchNos: data,
                    rpFlag: param
                };
                cpRecalculate(params).then(res => {
                    if (res && res.code === '0') {
                        if (res.data && res.data.exceptionFlag === 'Y') {
                            this.exceptionTip(res.data);
                        } else {
                            this.$message.success(tip);
                            this.getList();
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            } else if (data) {
                this.$message.warning('不存在可以操作的数据');
            };
        },
        exceptionTip (data) {
            const h = this.$createElement;
            this.$msgbox({
                title: '重算结果',
                message: h('p', {
                    style: 'color:red; cursor: pointer',
                    on: {
                        click: () => {
                            if (data.downloadUrl) {
                                window.location = data.downloadUrl;
                            }
                        }
                    }
                }, '点击下载异常表格数据'),
                showConfirmButton: false
            }).catch(() => {
                this.getList();
            });
        },
        // 校验
        verificationData() {
            if (!this.selected.length) {
                this.$message.warning('至少勾选一条数据进行操作');
                // 未勾选数据 返回false 避免重复提示
                return false;
            };
            // 过滤出 dispatchStatus <= 30 的数据，如果存在 将对应的发车单号提示出来,并终止执行
            const warningDispatchNo = this.selected.filter(item => +item.dispatchStatus <= 30);
            if (warningDispatchNo.length) {
                const warningTips = warningDispatchNo.map(item => item.dispatchNo).join(',');
                this.$message.warning(`发车单号为：${warningTips} 的订单，无发车记录，不允许重算，请重新勾选`);
                return false;
            };
            // 过滤出 符合条件的数据，并将dispatchNo组装为数组，用于接口传参
            const returnData = this.selected.filter(item => +item.dispatchStatus > 30).map(item => item.dispatchNo);
            // 全部不符合时，返回false，避免重复提示
            if (warningDispatchNo.length && !returnData.length) {
                return false;
            }
            return returnData;
        },
        // 批量操作-计费试算
        handleBillingTrial () {
            if (!this.selected.length) {
                return this.$message.warning('至少勾选一条数据进行操作');
            }
            // 已发车不允许试算
            const warningDispatchNo = this.selected.filter(item => +item.dispatchStatus >= 40);
            if (warningDispatchNo.length) {
                const warningTips = warningDispatchNo.map(item => item.dispatchNo).join(',');
                return this.$message.warning(`发车单号为: ${warningTips} 的订单，已发车不允许试算，请重新勾选！`);
            }
            const dispatchNos = this.selected.filter(item => +item.dispatchStatus < 40).map(v => v.dispatchNo);
            tryCalculation(dispatchNos).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('试算成功');
                    this.getList();
                }
            }).catch(() => { });
        },
        // 日趟数重算
        handleRankRecalculate () {
            if (!this.selected.length) {
                return this.$message.warning('至少勾选一条数据进行操作');
            }
            const paramList = this.selected.map(({ dispatchNo, vehicleCard, dispatchTime }) => ({ dispatchNo, vehicleCard, dispatchTime }));
            rankRecalculate(paramList)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.data);
                    }
                })
                .catch(() => { });
        },
        /**
         * @judgeCost 成本校验接口
         * @param {Object} copyRow 入参
         */
        judgeCost (copyRow) {
            judgeCost(copyRow).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.msg);
                    this.getList();
                }
            });
        },
        /**
         * @judgeCost 成本校验接口
         * @param {Object} copyRow 入参
         */
        startCostIflowApproval (copyRow) {
            startCostIflowApproval(copyRow).then(res => {
                if (res && +res.code === 0) {
                    window.open(res.data);
                    this.getList();
                }
            });
        },
        grantingPrivileges (data) {
            privilege([data.dispatchNo]).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('操作成功');
                    this.getList();
                }
            });
        },
        billingTrial (data) {
            if (data.dispatchStatus >= 40) {
                return this.$message.warning(`已发车不允许试算`);
            }
            tryCalculation([data.dispatchNo]).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('试算成功');
                    this.getList();
                }
            }).catch(() => { });
        },
        costAnomaly (data) {
            this.$router.push({
                path: '/performance/billing-abnormity-handle',
                query: {
                    dispatchNo: data.dispatchNo || ''
                }
            });
        },
        dispatchEdit (data) {
            this.$router.push({
                path: '/dispatch-order',
                query: {
                    dispatchNo: data.dispatchNo || ''
                }
            });
        },
        /**
         * @description 表格内按钮触发
         * @param {val} 当前值
         * @param {index} 当前索引
         * @param {rowData} 当前操作行数据
         */
        btnClick (val, index, rowData, prop) {
            if (prop === 'iflowLink' || prop === 'businessIflowUrl') {
                /* TODO: 用于金种子用户的iflow外链域名 */
                const obj = val.split('//');
                const obj1 = obj[1].split('/');
                const env = currentEnv();
                obj1[0] = seedIflowURLMap[env];
                window.open(obj1.join('/'));
            } else if (prop === 'transportLog') {
                this.componentsName = 'TransportationCostLog';
                this.componentsData = rowData;
            } else if (prop === 'dispatchStatusName') {
                bigDataLog.sendDetailMessageByKey('bigData-btn-dispatch-status');
                this.componentsData = rowData;
                this.isShowOperationNodeLog = true;
            }
        },
        /**
         * @description 组件名：编辑-运输成本
         */
        editTransportationCost (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-edit-costs');
            // 校验是否可编辑
            const isOk = isEditTransport(data);
            if (!isOk) return;
            this.componentsName = 'DispatchTransportationCost';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:位置信息页面
        */
        viewLocationInformation (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-location-information');
            this.componentsName = 'DispatchPositionInfo';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:到车登记
        */
        arrivalRegistration (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-arrival-registration');
            this.componentsName = 'DispatchArrivalRegistration';
            data.dictData = this.dictData;
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:明细装车
        */
        detailedLoading (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-detailed-loading');
            this.componentsName = 'DispatchDetailedLoading';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:取消到车
        */
        cancelArrival (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-cancel-arrival');
            this.componentsName = 'DispatchCancelArrival';
            data.dictData = this.dictData;
            this.componentsData = data;
        },
        handleCloseTip () {
            this.suspend = true;
            this.loading = false;
            this.dialogVisible = false;
        },
        handleOpenOldPrintf () {
            this.suspend = true;
            this.loading = false;
            this.dialogVisible = false;
            this.componentsName = 'DispatchPrint';
        },
        /**
         * @componentsName 组件名:打印
        */
        print (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-print');
            const virtualTable = this.$refs.tablePage.$refs.table.$refs.virtualTable;
            const elTable = virtualTable.$refs.elTable;
            elTable.clearCheckboxRow();
            virtualTable.newRows.forEach(item => {
                if (item.id === data.id) {
                    elTable.setCheckboxRow(item, true);
                }
            });
            this.handlePrint(data);
        },
        handlePrint (data) {
            this.batchPrint = false;
            this.timeout = false;
            this.componentsData = data;
            this.selected = [data];
            // 试点范围内，展示新的打印弹窗
            if (data.newPrintFlag) {
                this.loading = true;
                const timer = setTimeout(() => {
                    this.dialogVisible = true;
                    this.timeout = true;
                }, 7000);
                batchQueryTemplate({ dispatchNoList: [data.dispatchNo] }).then(res => {
                    clearTimeout(timer);
                    if (res && +res.code === 0 && !this.suspend) {
                        if (!res.data) {
                            this.componentsName = 'DispatchPrint';
                        } else {
                            this.printList = res.data || [];
                            this.isShowNewPrintDialog = true;
                        }
                    } else {
                        this.componentsName = 'DispatchPrint'; // 兜底接口报错，打开旧版打印
                    }
                })
                    .catch(() => { })
                    .finally(() => {
                        this.loading = false;
                        this.dialogVisible = false;
                    });
            } else {
                this.componentsName = 'DispatchPrint';
            }
        },
        handleBatchPrint () {
            if (!this.selected.length) {
                return this.$message.warning('至少选择一条数据');
            }
            if (this.selected.length > 10) {
                return this.$message.warning('最多选择10个发车单进行批量打印');
            }
            this.batchPrint = true;
            this.loading = true;
            const dispatchNoList = this.selected.map(v => v.dispatchNo);
            batchQueryTemplate({ dispatchNoList }).then(res => {
                if (res && +res.code === 0) {
                    this.printList = res.data || [];
                    this.isShowNewPrintDialog = true;
                }
            })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        printLog (rowData) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-print-log');
            this.componentsData = rowData;
            this.isShowPrintLogDialog = true;
        },
        /**
         * @description 回调函数，老版打印界面
         * @param {Object} data 行数据
        */
        openOldPrintDialog (componentsData) {
            this.$nextTick(() => {
                this.componentsName = 'DispatchPrint';
                this.componentsData = componentsData;
            });
        },
        /**
         * @componentsName 组件名:运输协议
        */
        transportProtocol (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-transportation-agreement');
            this.componentsName = 'DispatchTransportProtocol';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:轨迹回放
        */
        trajectoryPlay (data) {
            this.componentsName = 'DispatchTrajectoryPlay';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:整单装车
        */
        async wholeOrderLoading (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-whole-loading');
            const param = {
                dispatchNo: data.dispatchNo
            };
            // 整车装车校验明细数量
            const isDetailedLoading = await isValidateLoading(param);
            if (!isDetailedLoading) return;
            // 电子交接校验
            const loadCheckElectronic = await isValidateElectronic(param);
            if (!loadCheckElectronic) return;
            this.componentsName = 'DispatchWholeOrderLoading';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:发车单设备
        */
        dispatchDevice (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-device');
            this.componentsName = 'DispatchDevice';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:任务设备
        */
        taskDevice (data) {
            this.componentsName = 'TaskDevice';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:园区预约
        */
        parkAppoint (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-park-appointment');
            this.componentsName = 'DispatchParkAppoint';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:在途登记
        */
        onTheWay (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-transit-registration');
            this.componentsName = 'DispatchTransitRegistration';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:运抵
        */
        arrivalConfirmation (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-confirmation-arrival');
            this.componentsName = 'DispatchShipTo';
            data.dictData = this.dictData;
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:合同外线路
        */
        contractLine (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-cancel-distribute');
            this.componentsName = 'DispatchContractLine';
            this.componentsData = data;
        },
        /**
         * @componentsName 组件名:在途编辑
        */
        inTransitEdit (data) {
            this.componentsName = 'InTransitEdit';
            this.componentsData = data;
        },
        // 取消运抵
        cancelShipTo (data) {
            this.$confirm(`确定取消运抵吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                cancleArrivalConfirm({ dispatchNo: data.dispatchNo }).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('取消运抵成功');
                        this.getList();
                    }
                });
            }).catch(() => { });
        },
        // 成本校验
        costValidator (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-cost-verification');
            // 采购渠道为自调车才能启动成本校验
            if (data.procurementChannel !== '00') {
                return this.tipMes('只有采购渠道是自调车才能启动成本校验！');
            }
            // 目标成本有值和大于0
            if (data.standardCost && data.standardCost > 0) {
                return this.tipMes('目标成本已经存在，无需重复校验！');
            }
            lsrmCostVerification({
                dispatchNo: data.dispatchNo
            }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.msg || '操作成功');
                    this.getList();
                }
            });
        },
        // 成本校验
        costValidatorByCar (data) {
            // 采购渠道为自调车才能启动成本校验
            if (data.procurementChannel !== '00') {
                return this.tipMes('只有采购渠道是自调车才能启动成本校验！');
            }
            // 目标成本有值和大于0
            if (data.standardCost && data.standardCost > 0) {
                return this.tipMes('目标成本已经存在，无需重复校验！');
            }
            costVerificationByCar({
                dispatchNo: data.dispatchNo
            }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.msg || '操作成功');
                    this.getList();
                }
            });
        },
        // 成本审批
        costApprove (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-cost-approval');
            // 流程状态  C: "作废" N: "创建" P: "审批通过" R: "审批中"
            // 流程状态为创建、审批通过、审批中不能操作
            if (data.iflowStatus && data.iflowStatus !== 'C') {
                return this.tipMes('流程状态已经存在且未完结不能重新启动流程！');
            }
            // 目标成本没有,不能操作
            if (!(data.costRate + '')) {
                return this.tipMes('请先启动成本校验再启动MIP流程！');
            }
            createZdc({
                dispatchNo: data.dispatchNo
            }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('操作成功');
                    this.getList();
                }
            });
        },
        /**
         * @description 零担下发
         * @param {Object} data 行数据
         *
         */
        issue (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-contract-route');
            const params = {
                dispatchNo: data.dispatchNo
            };
            this.$confirm('确定要下发吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                queryLtlPlatform(params).then(res => {
                    if (res && +res.code === 0) {
                        if (res.data && res.data.length > 1) {
                            this.componentsName = 'DispatchIssueModal';
                            this.componentsData = {
                                dispatchNo: data.dispatchNo,
                                tableData: res.data
                            };
                        } else {
                            this.$message.success('下发成功');
                            this.getList();
                        }
                    }
                });
            }).catch(() => {

            });
        },
        /**
         * @description 取消零担下发
         * @param {Object} data 行数据
         *
         */
        cancelIssue (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-distribute');
            this.componentsName = 'DispatchCancelIssueModal';
            this.componentsData = data;
        },
        // 关闭组件
        componentsClose (data) {
            if (data === 'closePrintDialog') { // 关闭老版，关闭新版，不刷新页面
                this.componentsName = '';
                this.$nextTick(() => {
                    this.isShowNewPrintDialog = false;
                });
            } else if (data === 'closePrint') { // 关闭老版，不关闭新版，不刷新页面
                this.componentsName = '';
            } else {
                this.componentsName = '';
                this.getList();
            }
        },
        // 关闭备注弹窗
        closeRemarkDialog () {
            this.isShowRemarkDialog = false;
            this.getList();
        },
        // 关闭围栏备注弹窗
        closeFenceDialog () {
            this.isShowHandleReasonDialog = false;
            this.getList();
        },
        // 套牌车白名单校验 是否需要备注发车原因
        isHandleRemark (data) {
            let dispatchNoList = [];
            if (Array.isArray(data)) {
                dispatchNoList = data.map(v => v.dispatchNo);
            } else {
                dispatchNoList = [data.dispatchNo];
            }
            return isNeedExceptionRemarks(dispatchNoList).then(res => {
                if (res && +res.code === 0) {
                    return res.data;
                }
            }).catch(() => {
                return false;
            });
        },
        // 电子围栏校验，接口返回true则需要备注人工操作原因
        validateFence (data) {
            return checkLclOperate({ dispatchNo: data.dispatchNo }).then(res => {
                if (res && +res.code === 0) {
                    return res.data;
                }
            }).catch(() => {
                return false;
            });
        },
        /**
         * @description 发车
         * @param {Object} data 行数据
         * @param {Boolean} isRemarked （套牌车白名单校验）是否已备注发车原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async depart (data, isRemarked = false, isFenceRemarked = false) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-start');
            // 需要备注发车原因且未备注时
            if (!isRemarked) {
                // 校验是否需要备注发车原因
                const isValidate = await this.isHandleRemark(data);
                if (isValidate) {
                    this.isShowRemarkDialog = true;
                    this.componentsData = data;
                    return;
                };
            }
            // 电子围栏校验 提示和备注原因
            if (!isFenceRemarked) {
                // 校验是否需要提示和备注原因
                const isNeedTooltip = await this.validateFence(data);
                if (isNeedTooltip) {
                    this.$nextTick(() => {
                        this.isShowHandleReasonDialog = true;
                        this.componentsData = data;
                    });
                    return;
                }
            }
            // 继续发车操作
            const isTianjinWangHuo = isNoCarPlatformAndTianjinWangHuo(data);
            const params = [{ dispatchNo: data.dispatchNo }];
            if (isTianjinWangHuo) {
                const msg = `发车单号 ${data.dispatchNo} 已配置网货平台结算开票，点击发车后无法通过平台结算开票，请确认是否操作发车`;
                confirmBox(msg, params, this.dispatchDepart);
                return false;
            }
            this.dispatchDepart(params, 0);
        },
        /**
         * @description 批量发车
         * @param {Object} data 行数据
         * @param {Boolean} isRemarked 是否已备注发车原因
         */
        async handleBatchDepart (isRemarked = false) {
            // 校验是否选择数据且数据长度不能超过50条
            const isBatchDepart = validateIsBatchDepart(this.selected);
            if (!isBatchDepart) return;

            // 需要备注发车原因且未备注时
            if (!isRemarked) {
                // 校验是否需要备注发车原因
                const isValidate = await this.isHandleRemark(this.selected);
                if (isValidate) {
                    this.isShowRemarkDialog = true;
                    this.componentsData = this.selected;
                    return;
                };
            }

            const params = [];
            const dispatchNos = this.selected.map(v => v.dispatchNo);
            dispatchNos.forEach(item => {
                params.push({ dispatchNo: item });
            });
            this.btnLoading = true;
            this.dispatchDepart(params, 1);
        },
        // dispatchType 发车类型 0-单条 1-批量
        dispatchDepart (params, type = 0) {
            return updatedepart(params).then(res => {
                if (res && +res.code === 0) {
                    // 接口返回成功
                    if (Array.isArray(res.data) && res.data.length > 0) {
                        this.doDepartSuccess(res, type);
                    } else {
                        // 接口返回失败
                        this.doDepartFailed(res, type);
                    }
                }
            }).finally(() => {
                this.btnLoading = false;
            });
        },
        doDepartSuccess (res, dispatchType) {
            const total = res.data.length;
            const successTotal = res.data.filter(v => +v.success === 0).length;
            // 判断单条发车还是批量发车
            if (dispatchType && successTotal >= 0) {
                this.tipMes(`批量发车${total}条，成功${successTotal}条`);
            } else {
                successTotal === 1 ? this.$message.success(res.data[0].message || '发车成功') : this.$message.error(res.data[0].message);
            }
            if (+successTotal > 0) {
                this.getList();
                this.getListPageCount();
            }
        },
        doDepartFailed (res) {
            this.$message.error(`${res.data ? res.data[0].message : '发车失败'}`);
        },
        /**
     * @description 装车顺序
     * @param {Object} data 当前操作行数据
     */
        handleSequence (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-loading-sequence');
            this.componentsName = 'DispatchSequence';
            this.componentsData = data;
        },
        /**
         * @description 跳转至发车单在途监控，查看对应发车单轨迹
         * @param {Object} data 当前操作行数据
         */
        viewTrack (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-viewing-trajectories');
            this.$router.push({
                path: '/performance/dispatch-inroad-monitor',
                query: {
                    dispatchNo: data.dispatchNo
                }
            });
        },
        /**
         * @description 批量登记整车异常发车原因
         */
        handleRegistration () {
            // 校验是否可登记
            const isOk = isValidate(this.selected);
            if (!isOk) return;
            this.componentsName = 'DispatchAbnormalReason';
            this.componentsData = this.selected;
        },
        /**
         * @description 登记整车异常发车原因
         * @param {Object} data 当前操作行数据
         */
        abnormalReason (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-abnormal-reason');
            // 校验是否可登记
            const isOk = isValidate(data);
            if (!isOk) return;
            this.componentsName = 'DispatchAbnormalReason';
            this.componentsData = data;
        },

        // 查看发车照片
        photosBtn (row) {
            this.tableAttachmentList = [];
            this.tableAttachmentList.push({
                updateUserName: row.departPicUploadUserName,
                updateTime: row.departPicUploadTime,
                path: row.departPicUrl
            });
            this.$nextTick(() => {
                this.$refs.performancePreviewFile.show();
            });
        },
        /**
         * @description 车辆改派记录
         * @param {Object} data 当前操作行数据
         */
        vehicleRecord (data) {
            this.componentsName = 'DispatchVehicleRecord';
            this.componentsData = data;
        },
        /**
         * @description 发车重排
         * @param {Object} data 当前操作行数据
         */
        handleReset () {
            // 校验是否可重排
            const isOk = isValidateReset(this.selected);
            if (!isOk) return;
            this.handleResetLoading = true;
            const dispatchNoList = this.selected.map(v => v.dispatchNo);
            dispatchRearrange(dispatchNoList).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('操作成功');
                    this.getList();
                }
            }).finally(() => {
                this.handleResetLoading = false;
            });
        },

        /**
         * @description 取消装货
         * @param {Object} data 行数据
         */
        cancelLoading (data) {
            bigDataLog.sendDetailMessageByKey('bigData-btn-cancel-loading');
            cancelLoadStatus(data.dispatchNo).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('操作成功');
                    this.getList();
                }
            });
        },
        /**
         * @tipMes 提示
         * @mes {string} 提示语
         * @duration {string} 显示时间
         */
        tipMes (mes, duration = 4000) {
            this.$message({
                type: 'warning',
                duration: duration,
                dangerouslyUseHTMLString: true,
                message: mes,
                showClose: true
            });
        },
        cellStyle (row, col) {
            if (col.prop === 'driverOrderStatusName' && +row.driverOrderStatus === 0) {
                return 'color: red; font-weight: bold';
            } else if (col.prop === 'expectedResultName' && +row.expectedResult === 1) {
                return 'color: red; font-weight: bold';
            } else if (col.prop === 'currentAlertTypeName' && +row.currentAlertType === 0) {
                return 'color: #00bcbf';
            } else {
                return '';
            }
        },
        /**
     * @description 获取数据字典
     * @param {string} 数据字典编码字符串
     * @return {Object} 数据字典集合
     * 签署协议状态: TP_DISPATCH_STATUS
     * 审批状态: NEW_TMS_IFLOW_STATUS
     * 是否可见: CARRIER_VISIBLE_FLAG
     * 是否无车平台: OTP_NOCAR_PLATFROM
     * 无车平台类型: NO_CAR_CARRIER_TYPE
     * 是否串点计费: YES_OR_NO_STRING_POINT
     * 采购渠道: OTP_TMS_PROCUREMENT_CHANNEL
     * 发车单状态: DISPATCH_STATUS
     * 到车登记方式: PICK_UP_TYPE
     * 设备类型: DEVICETYPE
     * 预付方式: SYS_TMS_PAY_METHOD
     * 装载过低异常类型: EXCEPTION_TYPE
     * 发运类型: TMS_SHIPPING_TYPE
     * 运输方式: EC_TRANSPORT_TYPE
     * 是否下发零担平台: IS_ISSUE
     * 下发零担状态: LCL_STATUS
     * 装载类型: NEW_TMS_LOAD_TYPE
     * 站点类型: SITE_TYPE
     * 到车标识: ARRIVE_STATUS
     * 出入库类型: OTP_IN_OUT_TYPE,
     * 附件类型: OTP_ATTACHMENT_TYPE
     * 发车方式：DISPATCH_WAY
     * 抵达方式：ARRIVER_WAY
     * 配送方式：DELIVERY_TYPE
     * 异常发车原因: ABNORMAL_DEPART_REASON
     */
        async getDicData () {
            const dict = await dictWithUrl(
                // eslint-disable-next-line max-len
                'TP_DISPATCH_STATUS,NEW_TMS_IFLOW_STATUS,OTP_IN_OUT_TYPE,CARRIER_VISIBLE_FLAG,OTP_NOCAR_PLATFROM,NO_CAR_CARRIER_TYPE,YES_OR_NO_STRING_POINT,OTP_TMS_PROCUREMENT_CHANNEL,DISPATCH_STATUS,PICK_UP_TYPE,DEVICETYPE,SYS_TMS_PAY_METHOD,EXCEPTION_TYPE,TMS_SHIPPING_TYPE,EC_TRANSPORT_TYPE,LCL_STATUS,IS_ISSUE,NEW_TMS_LOAD_TYPE,SITE_TYPE,ARRIVE_STATUS,OTP_ATTACHMENT_TYPE,DISPATCH_WAY,ARRIVER_WAY,DELIVERY_TYPE,TMS_CONTRACT_SITUATION,ABNORMAL_DEPART_REASON,PRINT_TEMPLATE_STYLE_ATTRIBUTE,ANNTO_FORMWORK_OTP,DRIVER_ORDER_STATUS,CURRENT_ALERT_TYPE,EXPECTED_RESULT,NEW_PRINTF_TIP_TEXT,NEW_PRINTF_TIP_URL,DISPATCH_GOODS_REPORT_NUM,TMS_OPERATION_NODE,OPERATION_LOG_ATTACHMENT_TYPE'
            );
            this.importConfig.ImportContent[0].downLoadInfo.url = dict.data.ANNTO_FORMWORK_OTP.DISPATCH_MANAGE_IMPORT;
            this.dictData = dict.data;
        },
        async getContractLine () {
            this.dictContractLine = await dictWithUrl('CONTRACT_OUT_LINE');
        }

    },
    mounted () {
        this.getDicData();
        this.getContractLine();
        this.getMaxSearchLimit();
        this.queryCompanyConfig();
        this.changeConfig();
    }

};
</script>

<style lang="less">
@import './dispatchOrder.less';
</style>
